/* eslint-disable no-useless-computed-key */
import { FlexBox } from "components";
import AppPage from "components/AppPage";
import AppActions from "actions/App";
import RulerBar from "components/RulerBar";
import * as Icons from "components/Material/SvgIcons";
import {
  TextField,
  DatePicker,
  Dialog,
  Paper,
  RaisedButton,
  SelectField,
  Tab,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  Tabs,
  IconButton,
  FloatingActionButton,
} from "material-ui";
import { translate as _l } from "oxygen-i18n";
import React, { Component, PropTypes } from "react";
import { mixin, RefluxMixin } from "Util";
import * as SvgIcons from "components/Material/SvgIcons";

addTranslations({
  ["en-US"]: {
    type: "Product",
    name: "Name",
    sales: "Sales",
    source: "Source",
    users: "Users",
    "Total sales": "Total sales",
    "Gifts sold": "Total gifts sold",
    Invitations: "Invitations",
    Total: "Total",
    "Total amount": "Total amount",
    "Total quantity": "Totalt quantity",
    PageViews: "Page views",
    TotalTimeSpent: "Average time spent",
    TimeSpent: "Avg time spent",
    page: "Page",
    sessions: "Sessions",
    Accepted: "Accepted",
    Amount: "Amount",
    Quantity: "Quantity",
    Conversion: "Conversion",
    Page: "Page",
    "Total amount of page views": "Total amount of page views",
    Interaction: "Course Interaction",
    "Interaction Type": "Interaction Type",
    "No interaction data collected": "No interaction data collected",
    close: "close",
    "Course Interactions": "Course Interactions",
    Instructions: "Instructions",
    "To see interactions for each page click any row in the table":
      "To see interactions for each page click any row in the table",
    task_interaction: "Interaction with Task",
    video_interaction: "Video",
    slideshow_interaction: "Slideshow",
    download_interaction: "Download",
    discussion_interaction: "Discussion",
    audio_interaction: "Sound",
    google_warning: "There is no Google Data for dates previous to 2019",
    "n/a": "n/a",
    exportDone: "Statistics export was sent to your email.",
    NoSalesData: "No sales data found try to expande the time range",
    NoInvitationData: "No invitation data found try to expande the time range",
  },
  ["sv-SE"]: {
    type: "Produkt",
    name: "Namn",
    sales: "Försäljning",
    source: "Ursprung",
    users: "Besökare",
    "Total sales": "Totalförsäljning",
    "Total amount": "Totalbelopp",
    "Total quantity": "Totalt antal",
    "Gifts sold": "Gåvor sålda",
    PageViews: "Sidvisningar",
    TotalTimeSpent: "Total tid spenderad",
    TimeSpent: "Genomsnittlig tid spenderad",
    page: "Sida",
    sessions: "Sessioner",
    Invitations: "Inbjudningar",
    Total: "Totalt",
    Accepted: "Accepterade",
    Amount: "Summa",
    Quantity: "Antal",
    Conversion: "Konverteringsgrad",
    Page: "Sida",
    "Interaction Type": "Typ av händelse",
    "No interaction data collected": "Ingen händelse data insamlad",
    close: "stäng",
    Interaction: "Kursanvändning",
    "Total amount of page views": "Totalt antal sidvisningar",
    "Course Interactions": "Interaktion med kursen",
    Instructions: "Instruktioner",
    "To see interactions for each page click any row in the table":
      "För att se detaljer klick på valfri rad i tabellen",
    task_interaction: "Uppgift",
    video_interaction: "Video",
    slideshow_interaction: "Slideshow",
    download_interaction: "Nedladdning",
    discussion_interaction: "Diskussion",
    audio_interaction: "Ljud",
    google_warning: "Det finns ingen Google Data för datum tidigare än 2019",
    "n/a": "n/a",
    exportDone: "Statestiken har exporterats och skickats till din mail",
    NoSalesData: "Ingen försäljningsdata funnen prova att utöka tidsrymden",
    NoInvitationData: "Ingen inbjudningsdata funnen prova att utöka tidsrymden",
  },
});

const css = oxygenCss({
  box: {
    textAlign: "center",
    width: "calc(100%)",
    padding: "20px",
    fontSize: "2em",
    marginTop: "20px",
    marginLeft: "20px",
    marginRight: "20px",
    marginBottom: 0,
    boxShadow: "0 3px 18px rgba(0, 0, 0, 0.18)",
    borderRadius: "10px",
  },
  date: {
    lineHeight: "48px",
    margin: 0,
    marginRight: "10px",
  },
  flex: {
    width: "50%",
    "@phone": {
      width: "100%",
    },
  },
  graph: {
    "@phone": {
      display: "none",
    },
  },
  dropdown: {
    left: "50%",
    transform: "translateX(-50%)",
    position: "relative",
    display: "inline-block",
    "DIV DIV": {
      ":nth-child(2)": {
        position: "relative!important",
      },
    },
  },
});

const SALES_TAB = "sales";
const USAGE_TAB = "usage";

export default class StatisticsContainer extends mixin(RefluxMixin, Component) {
  constructor(props) {
    super(props);
    let now = new Date();
    let startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    let endDate = new Date();
    this.state = {
      startDate: startDate,
      endDate: endDate,
      loading: true,
      labels: [],
      lineData: [],
      invitations: {
        count: 0,
        acceptedCount: 0,
        invPerCourse: [],
        invPerCircle: [],
      },
      clickData: [],
    };
  }

  setDate = (data) => {
    this.setState(data);
  };

  componentWillMount() {
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;
    this.fetchStats(startDate, endDate);
    //this.fetchInvitations(startDate, endDate);
    //this.fetchEventStats({ startDate, endDate });
  }

  fetchEventStats = (
    {
      startDate,
      endDate,
      dimensions,
      fetchStore,
      metrics,
      filters,
      courseId,
      sort,
    },
    key = "data"
  ) => {
    return SteelCompass.request("statistics", "queryAnalytics", {
      startDate:
        startDate.getFullYear() +
        "-" +
        ("0" + (startDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + startDate.getDate()).slice(-2),
      endDate:
        endDate.getFullYear() +
        "-" +
        ("0" + (endDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + endDate.getDate()).slice(-2),
      dimensions: dimensions || "ga:source",
      fetchStore,
      metrics: metrics || "ga:users",
      filters,
      courseId,
      sort,
    })
      .then((response) => {
        const data = [];
        response.forEach((arr) => {
          data.push(Object.assign({}, arr));
        });
        this.setState((state) => ({
          ...state,
          [key]: data,
        }));
        return response;
      })
      .catch((error) =>
        this.setState((state) => ({
          ...state,
          error,
        }))
      );
  };

  fetchStats = (startDate, endDate) => {
    SteelCompass.request("statistics", "sales", {
      startDate:
        startDate.getDate() +
        "." +
        (startDate.getMonth() + 1) +
        "." +
        startDate.getFullYear(),
      endDate:
        endDate.getDate() +
        "." +
        (endDate.getMonth() + 1) +
        "." +
        endDate.getFullYear(),
    }).then((response) => {
      let data = this.groupData(startDate, endDate, response);
      this.setState((state) => ({
        ...state,
        ...data,
        ...response,
        loading: false,
      }));
    });
  };

  fetchInvitations = (startDate, endDate) => {
    SteelCompass.request("statistics", "invitations", {
      startDate:
        startDate.getDate() +
        "." +
        (startDate.getMonth() + 1) +
        "." +
        startDate.getFullYear(),
      endDate:
        endDate.getDate() +
        "." +
        (endDate.getMonth() + 1) +
        "." +
        endDate.getFullYear(),
    }).then((response) => {
      const { count, acceptedCount, invPerCourse, invPerCircle } = response;
      let invitations = { count, acceptedCount, invPerCourse, invPerCircle };

      this.setState((state) => ({
        ...state,
        invitations,
        loading: false,
      }));
    });
  };

  groupData(startDate, endDate, data) {
    let period = (endDate - startDate) / (24 * 60 * 60 * 1000);
    let { dates, sums } = data;
    let lookup = {};
    for (let i = 0; i < dates.length; i++) {
      let date = new Date(dates[i]);
      date.setHours(12);
      lookup[date.getTime()] = (lookup[dates[i]] || 0) + parseFloat(sums[i]);
    }
    if (period <= 31) {
      return this.groupDataInDays(startDate, endDate, lookup);
      // } else if (period <= 90) {
      //   return this.groupDataInWeeks(startDate, endDate, lookup);
    } else if (period <= 365) {
      return this.groupDataInMonths(startDate, endDate, lookup);
    } else {
      return this.groupDataInYears(startDate, endDate, lookup);
    }
  }

  groupDataInDays(startDate, endDate, lookup) {
    let days = 0;
    let data = {
      labels: [],
      lineData: [],
    };
    let date = new Date(startDate.valueOf());
    while (date <= endDate) {
      date = new Date(startDate.valueOf());
      date.setDate(date.getDate() + days);
      date.setHours(12);
      let time = date.getTime();
      let readable = date.toDateString();
      data.labels.push(readable);
      data.lineData.push(lookup[time] || 0);
      days++;
    }
    return data;
  }

  groupDataInWeeks(startDate, endDate, lookup) {
    let days = 0;
    let data = {
      labels: [],
      lineData: [],
    };
    let date = new Date(startDate.valueOf());
    while (date <= endDate) {
      date = new Date(startDate.valueOf());
      date.setDate(date.getDate() + days);
      date.setHours(12);
      let time = date.getTime();
      let readable = date.toDateString();
      data.labels.push(readable);
      data.lineData.push(lookup[time] || 0);
      days++;
    }
    return data;
  }

  groupDataInMonths(startDate, endDate, lookup) {
    let days = 0;
    let data = {
      labels: [],
      lineData: [],
    };
    let grouped = {};
    let date = new Date(startDate.valueOf());

    while (date <= endDate) {
      date = new Date(startDate.valueOf());
      date.setDate(date.getDate() + days);
      date.setHours(12);
      let time = date.getTime();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let readable = year + "-" + month;
      grouped[readable] = (grouped[readable] || 0) + (lookup[time] || 0);
      days++;
    }
    data.labels = Object.keys(grouped);
    data.labels.forEach((key) => {
      data.lineData.push(grouped[key]);
    });
    return data;
  }

  groupDataInYears(startDate, endDate, lookup) {
    let days = 0;
    let data = {
      labels: [],
      lineData: [],
    };
    let grouped = {};
    let date = new Date(startDate.valueOf());
    while (date <= endDate) {
      date = new Date(startDate.valueOf());
      date.setDate(date.getDate() + days);
      date.setHours(12);
      let time = date.getTime();
      let year = date.getFullYear();
      let readable = year;
      grouped[readable] = (grouped[readable] || 0) + (lookup[time] || 0);
      days++;
    }
    data.labels = Object.keys(grouped);
    data.labels.forEach((key) => {
      data.lineData.push(grouped[key]);
    });
    return data;
  }

  render() {
    return (
      <StatisticsPage
        setDate={this.setDate}
        fetchStats={this.fetchStats}
        fetchInvitations={this.fetchInvitations}
        fetchEventStats={this.fetchEventStats}
        {...this.props}
        {...this.state}
      />
    );
  }
}

class StatisticsPage extends Component {
  state = {
    currentTab: SALES_TAB,
    selectedCourse: null,
    recipientEmail: "",
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func,
  };

  tabChange = (value) => {
    this.setState({ currentTab: value });
  };

  selectedCourse = (id) => {
    this.setState({ selectedCourse: id });
  };

  setStartDate = (_, startDate) => {
    if (this.props.startDate !== startDate) {
      this.props.setDate({ startDate });
      this.props.fetchStats(startDate, this.props.endDate);
      this.props.fetchInvitations(startDate, this.props.endDate);
    }
  };

  setEndDate = (_, endDate) => {
    if (this.props.endDate !== endDate) {
      this.props.setDate({ endDate });
      this.props.fetchStats(this.props.startDate, endDate);
      this.props.fetchInvitations(this.props.startDate, endDate);
    }
  };

  handleChangeExport = (e) => {
    this.setState({ recipientEmail: e.target.value });
  };

  exportStatistics = () => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let email = null;
    if (re.test(String(this.state.recipientEmail).toLowerCase())) {
      email = this.state.recipientEmail;
    }
    SteelCompass.request("statistics", "interaction", {
      startDate: this.refs.startDate.getDate(),
      endDate: this.refs.endDate.getDate(),
      courseId: this.state.selectedCourse,
      recipientEmail: email,
    }).then(
      (response) => {
        AppActions.translatableMessage(_l`exportDone`);
        this.refs.exportDialog.dismiss();
      },
      (error) => {
        AppActions.genericError(error);
        this.refs.exportDialog.dismiss();
      }
    );
  };

  render() {
    let tab = null;

    switch (this.state.currentTab) {
      case SALES_TAB:
        tab = (
          <StatisticsSalesTab
            {...this.props}
            selectedCourse={this.selectedCourse}
          />
        );
        break;
      case USAGE_TAB:
        tab = (
          <StatisticsUsageTab
            {...this.props}
            selectedCourse={this.selectedCourse}
          />
        );
        break;
      default:
        tab = (
          <StatisticsSalesTab
            {...this.props}
            selectedCourse={this.selectedCourse}
          />
        );
        break;
    }

    const exportActions = [
      { text: this.context.getIntlMessage("Cancel") },
      {
        text: this.context.getIntlMessage("Export"),
        onTouchTap: this.exportStatistics,
        ref: "submit",
      },
    ];

    return (
      <AppPage header={<RulerBar title="Statistics" />}>
        <FlexBox style={{ margin: "auto", maxWidth: 1200 }} row>
          <FlexBox
            style={{ justifyContent: "center" }}
            className={css.flex}
            grow={0}
            shrink={0}
          >
            <p className={css.date}>Start Date:</p>
            <DatePicker
              maxDate={this.props.endDate}
              onChange={this.setStartDate}
              value={this.props.startDate}
              hintText="Start date"
              ref="startDate"
            />
          </FlexBox>
          <FlexBox
            style={{ justifyContent: "center" }}
            className={css.flex}
            grow={0}
            shrink={0}
          >
            <p className={css.date}>End Date:</p>
            <DatePicker
              minDate={this.props.startDate}
              onChange={this.setEndDate}
              value={this.props.endDate}
              hintText="End date"
              ref="endDate"
            />
          </FlexBox>
          <FlexBox>
            <FloatingActionButton
              style={{ transform: "translateY(-50%)", zIndex: 10 }}
              onClick={this.refs.exportDialog && this.refs.exportDialog.show}
            >
              <SvgIcons.ActionLaunch />
            </FloatingActionButton>
          </FlexBox>
        </FlexBox>
        <StatisticsPageNavigation changeTab={this.tabChange} />
        <div style={{ height: "auto" }}>{tab}</div>
        <Dialog
          ref="exportDialog"
          title={_l`customExport`}
          actions={exportActions}
          actionFocus="export"
          dismissOnClickAway={true}
        >
          <TextField
            onChange={this.handleChangeExport}
            floatingLabelText=""
            hintText="Email"
          />
        </Dialog>
      </AppPage>
    );
  }
}

class StatisticsPageNavigation extends Component {
  render() {
    const { changeTab } = this.props;
    return (
      <Tabs style={{ maxWidth: 1200, margin: "auto" }} onChange={changeTab}>
        <Tab label="Sales" value={SALES_TAB} />
        <Tab label="Usage" value={USAGE_TAB} />
      </Tabs>
    );
  }
}

class StatisticsSalesTab extends Component {
  state = {
    loading: false,
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.startDate !== this.props.startDate ||
      nextProps.endDate !== this.props.endDate
    ) {
      this.props
        .fetchEventStats(
          {
            startDate: nextProps.startDate,
            endDate: nextProps.endDate,
            dimensions: "ga:pagePath",
            metrics: "ga:sessions, ga:avgSessionDuration",
            sort: "-ga:sessions",
            fetchStore: true,
          },
          "pageData"
        )
        .then(() => this.setState({ loading: false }));
    }
  }

  componentWillMount() {
    this.props
      .fetchEventStats(
        {
          startDate: this.props.startDate,
          endDate: this.props.endDate,
          dimensions: "ga:pagePath",
          metrics: "ga:sessions, ga:avgSessionDuration",
          sort: "-ga:sessions",
          fetchStore: true,
        },
        "pageData"
      )
      .then(() => this.setState({ loading: false }));
  }

  populateSalesDataWithGA(
    id,
    slug,
    name,
    salesCount,
    salesAmount,
    storeCurrency,
    hasGoogleData
  ) {
    let gaData = null;
    for (let i = 0; i < this.props.pageData.length; i++) {
      if (this.props.pageData[i] && this.props.pageData[i][0].includes(slug)) {
        gaData = this.props.pageData[i];
        break;
      }
    }
    if (gaData && hasGoogleData) {
      const minutes = Math.floor(gaData[2] / 60);
      const seconds = Math.floor(gaData[2] - minutes * 60);
      const sessions = +gaData[1];

      return (
        <TableRow key={id}>
          <TableRowColumn style={{ fontSize: "15px" }}>{name}</TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>
            {salesCount}
          </TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>
            {Math.round(salesAmount)} {storeCurrency}
          </TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>
            {gaData[1]}
          </TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>
            {minutes},{seconds}
          </TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>
            {
              sessions ?
              ((salesCount / sessions) * 100).toFixed(1) > 30 ?
                'N/A'
                :
                `${((salesCount / sessions) * 100).toFixed(1)}%`
              :
              'N/A'
            }
          </TableRowColumn>
        </TableRow>
      );
    } else {
      return (
        <TableRow key={id}>
          <TableRowColumn style={{ fontSize: "15px" }}>{name}</TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>
            {salesCount}
          </TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>
            {Math.round(salesAmount)}
          </TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>-</TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>-</TableRowColumn>
          <TableRowColumn style={{ fontSize: "15px" }}>-</TableRowColumn>
        </TableRow>
      );
    }
  }

  sumConversion = (pageData, salesPerObject) => {
    const totalSales = salesPerObject
      .map((x) => x.type === "course" && x.salesCount)
      .reduce((a, b) => b + a, 0);
    const totalSessions = pageData.reduce((a, b) => {
      const slug = salesPerObject.find((x) => b[0].includes(x.slug));
      if (!slug) {
        return a;
      }
      return (a += Math.round(Number(b[1])));
    }, 0);
    if (((totalSales / totalSessions) * 100).toFixed(1) === 'Infinity') {
      return 'N/A';
    } else {
      const result = ((totalSales / totalSessions) * 100).toFixed(1);
      return result > 30 ? 'N/A' : `${result}%`
    }
  };

  render() {
    const {
      salesPerObject,
      pageData,
      loading,
      totalValue,
      invitations,
      storeCurrency,
    } = this.props;

    const hasGoogleData = new Date(this.props.startDate).getFullYear() >= 2019;
    const currency = storeCurrency || "SEK";
    const formatter = new Intl.NumberFormat(
      currency === "SEK" ? "sv-SE" : "en-US",
      {
        style: "currency",
        currency,
        minimumFractionDigits: 0,
      }
    );
    return (
      <div
        style={{
          overflowY: "scroll",
          height: "calc(100vh - 200px)",
        }}
      >
        <div style={{ margin: 20, marginLeft: "34px" }}>
          {(!loading && !!pageData && !!salesPerObject.length && (
            <Paper style={{ maxWidth: 1200, margin: "auto" }}>
              <h2
                style={{
                  fontSize: 22,
                  lineHeight: "28px",
                  borderRadius: "2px",
                  padding: "20px",

                  background: "#777",
                  color: "#fff",
                }}
              >{_l`sales`}</h2>
              {!hasGoogleData && (
                <p
                  style={{
                    color: "red",
                    marginLeft: "20px",
                    fontSize: "16px",
                  }}
                >{_l`google_warning`}</p>
              )}
              <Table
                fixedHeader={true}
                fixedFooter={true}
                selectable={false}
                multiSelectable={false}
              >
                <TableHeader
                  selectAllSelected={false}
                  adjustForCheckbox={false}
                  displaySelectAll={false}
                  enableSelectAll={false}
                >
                  <TableRow>
                    <TableHeaderColumn
                      style={{ color: "#656565", fontSize: "13px" }}
                      tooltip={_l`name`}
                    >
                      {_l`name`}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      style={{ color: "#656565", fontSize: "13px" }}
                      tooltip={_l`Quantity`}
                    >
                      {_l`Quantity`}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      style={{ color: "#656565", fontSize: "13px" }}
                      tooltip={_l`Amount`}
                    >
                      {_l`Amount`}
                    </TableHeaderColumn>
                    {hasGoogleData && (
                      <TableHeaderColumn
                        style={{ color: "#656565", fontSize: "13px" }}
                        tooltip={_l`PageViews`}
                      >
                        {_l`PageViews`}
                      </TableHeaderColumn>
                    )}
                    {hasGoogleData && (
                      <TableHeaderColumn
                        style={{ color: "#656565", fontSize: "13px" }}
                        tooltip={_l`TotalTimeSpent`}
                      >
                        {_l`TotalTimeSpent`}
                      </TableHeaderColumn>
                    )}
                    {hasGoogleData && (
                      <TableHeaderColumn
                        style={{ color: "#656565", fontSize: "13px" }}
                        tooltip={_l`Conversion`}
                      >
                        {_l`Conversion`}
                      </TableHeaderColumn>
                    )}
                  </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false} stripedRows={false}>
                  {salesPerObject.map(
                    ({ id, slug, type, name, salesCount, salesAmount }) => {
                      if (type === "course" || type === "package") {
                        return this.populateSalesDataWithGA(
                          id,
                          slug,
                          name,
                          salesCount,
                          salesAmount,
                          storeCurrency,
                          hasGoogleData
                        );
                      } else {
                        return null;
                      }
                    }
                  )}
                  <TableRow>
                    <TableRowColumn />
                    <TableRowColumn style={{ fontSize: "15px" }}>
                      <strong>
                        {_l`Total`}:{" "}
                        {!!salesPerObject.length
                          ? salesPerObject
                              .map((x) => x.salesCount)
                              .reduce((a, b) => b + a)
                          : 0}
                      </strong>
                    </TableRowColumn>
                    <TableRowColumn style={{ fontSize: "15px" }}>
                      <strong>
                        {_l`Total`}: {formatter.format(Math.round(totalValue))}
                      </strong>
                    </TableRowColumn>
                    {hasGoogleData && (
                      <TableRowColumn style={{ fontSize: "15px" }}>
                        <strong>
                          {_l`Total`}:{" "}
                          {hasGoogleData &&
                            pageData &&
                            !!pageData.length &&
                            pageData.reduce((a, b) => {
                              const slug = salesPerObject.find((x) =>
                                b[0].includes(x.slug)
                              );
                              if (!slug) {
                                return a;
                              }
                              return (a += Math.round(Number(b[1])));
                            }, 0)}
                        </strong>
                      </TableRowColumn>
                    )}
                    {hasGoogleData && (
                      <TableRowColumn style={{ fontSize: "15px" }}>
                        <strong>
                          {_l`Total`}:{" "}
                          {hasGoogleData &&
                            pageData &&
                            !!pageData.length &&
                            Math.round(
                              pageData.reduce((a, b) => {
                                const slug = salesPerObject.find((x) =>
                                  b[0].includes(x.slug)
                                );
                                if (!slug) {
                                  return a;
                                }
                                return (a += Math.round(Number(b[2])));
                              }, 0) / 60
                            )}{" "}
                          min
                        </strong>
                      </TableRowColumn>
                    )}
                    {hasGoogleData && (
                      <TableRowColumn style={{ fontSize: "15px" }}>
                        <strong>
                          {_l`Total`}:{" "}
                          {pageData &&
                            !!pageData.length &&
                            this.sumConversion(pageData, salesPerObject)}
                        </strong>
                      </TableRowColumn>
                    )}
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          )) || (
            <Paper style={{ maxWidth: 1200, margin: "auto", padding: 20 }}>
              {" "}
              <h2>{_l`NoSalesData`}</h2>{" "}
            </Paper>
          )}
        </div>
        <div style={{ margin: 20, marginLeft: "34px" }}>
          {(!loading &&
            !!invitations &&
            (!!invitations.invPerCourse.length ||
              !!invitations.invPerCircle.length) && (
              <Paper style={{ maxWidth: 1200, margin: "auto" }}>
                <h2
                  style={{
                    fontSize: 22,
                    lineHeight: "28px",
                    borderRadius: "2px",
                    padding: "20px",

                    background: "#777",
                    color: "#fff",
                  }}
                >{_l`Invitations`}</h2>
                <Table
                  fixedHeader={true}
                  selectable={false}
                  multiSelectable={false}
                >
                  <TableHeader
                    selectAllSelected={false}
                    adjustForCheckbox={false}
                    displaySelectAll={false}
                    enableSelectAll={false}
                  >
                    <TableRow>
                      <TableHeaderColumn
                        style={{ color: "#656565", fontSize: "13px" }}
                        tooltip={_l`name`}
                      >
                        {_l`name`}
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        style={{ color: "#656565", fontSize: "13px" }}
                        tooltip={_l`sales`}
                      >
                        {_l`Invitations`}
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        style={{ color: "#656565", fontSize: "13px" }}
                        tooltip={_l`sales`}
                      >
                        {_l`Accepted`} {_l`Invitations`}
                      </TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false} stripedRows={false}>
                    {invitations.invPerCourse.map(
                      ({ id, name, count, acceptedCount }) => (
                        <TableRow key={id}>
                          <TableRowColumn style={{ fontSize: "15px" }}>
                            {name}
                          </TableRowColumn>
                          <TableRowColumn style={{ fontSize: "15px" }}>
                            {count}
                          </TableRowColumn>
                          <TableRowColumn style={{ fontSize: "15px" }}>
                            {acceptedCount}
                          </TableRowColumn>
                        </TableRow>
                      )
                    )}
                    {invitations.invPerCircle.map(
                      ({ id, name, count, acceptedCount }) => (
                        <TableRow key={id}>
                          <TableRowColumn style={{ fontSize: "15px" }}>
                            {name}
                          </TableRowColumn>
                          <TableRowColumn style={{ fontSize: "15px" }}>
                            {count}
                          </TableRowColumn>
                          <TableRowColumn style={{ fontSize: "15px" }}>
                            {acceptedCount}
                          </TableRowColumn>
                        </TableRow>
                      )
                    )}
                    <TableRow>
                      <TableRowColumn />
                      <TableRowColumn style={{ fontSize: "15px" }}>
                        <strong>
                          {_l`Total`}: {invitations.count}
                        </strong>
                      </TableRowColumn>
                      <TableRowColumn style={{ fontSize: "15px" }}>
                        <strong>
                          {_l`Total`}: {invitations.acceptedCount}
                        </strong>
                      </TableRowColumn>
                    </TableRow>
                  </TableBody>
                </Table>
              </Paper>
            )) || (
            <Paper style={{ maxWidth: 1200, margin: "auto", padding: 20 }}>
              {" "}
              <h2>{_l`NoInvitationData`}</h2>{" "}
            </Paper>
          )}
        </div>
      </div>
    );
  }
}

class StatisticsUsageTab extends Component {
  state = {
    loading: true,
    loadingDetails: true,
    courses: [],
    selectedCourse: null,
    sortingTable: null,
    sortBy: false,
    sortOrder: false,
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.startDate !== this.props.startDate ||
      nextProps.endDate !== this.props.endDate
    ) {
      if (this.state.selectedCourse) {
        this.setState({ loading: true });
        this.props.fetchEventStats({
          startDate: nextProps.startDate,
          endDate: nextProps.endDate,
          filters: `ga:pagePath=@/${this.state.selectedCourse}/`,
          dimensions: "ga:pagePath",
          metrics: "ga:sessions, ga:avgSessionDuration",
          sort: "-ga:avgSessionDuration",
          courseId: this.state.courseId,
        });
        this.props
          .fetchEventStats(
            {
              startDate: nextProps.startDate,
              endDate: nextProps.endDate,
              filters: `ga:pagePath=@${this.state.selectedCourse}`,
              dimensions: "ga:pagePath,ga:eventAction",
              metrics: "ga:totalEvents",
              sort: "-ga:totalEvents",
              courseId: this.state.courseId,
            },
            "interactionData"
          )
          .then(() => this.setState({ loading: false }));
      }
    }
  }

  componentWillMount() {
    this.fetchCourses();
  }

  fetchCourses = () => {
    SteelCompass.request("course", "findBuildable").then((courses) => {
      this.setState((state) => ({
        ...state,
        courses,
      }));
    });
  };

  handleChange = (_, __, menuItem) => {
    if (
      menuItem.payload === this.state.selectedCourse ||
      menuItem.payload === "none"
    ) {
      return;
    }

    this.props.selectedCourse(menuItem.id);

    this.props.fetchEventStats({
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      dimensions: "ga:pagePath",
      metrics: "ga:sessions, ga:avgSessionDuration",
      sort: "-ga:avgSessionDuration",
      filters: `ga:pagePath=@/${menuItem.payload}/`,
      courseId: menuItem.id,
    });

    this.props
      .fetchEventStats(
        {
          startDate: this.props.startDate,
          endDate: this.props.endDate,
          filters: `ga:pagePath=@${menuItem.payload}`,
          dimensions: "ga:pagePath,ga:eventAction",
          metrics: "ga:totalEvents",
          sort: "-ga:totalEvents",
          courseId: menuItem.id,
        },
        "interactionData"
      )
      .then(() => this.setState({ loading: false }));

    this.setState((state) => ({
      ...state,
      selectedCourse: menuItem.payload,
      courseId: menuItem.id,
    }));
  };

  mapUsageData = (data) => {
    return data.map((obj) => {
      let sessions = 0;
      let avgSessionDuration = 0;
      if (obj.gaData.length) {
        obj.gaData.forEach((item) => {
          avgSessionDuration +=
            item.avgSessionDuration && Number(item.avgSessionDuration);
          sessions += item.sessions && Number(item.sessions);
        });
      }
      return { ...obj, avgSessionDuration, sessions };
    });
  };

  mapInteractionData = (data) => {
    let flatList = [];
    data.forEach((item) => {
      let numberOfgaItems = item.gaData.length;
      if (numberOfgaItems === 1) {
        flatList.push({
          sectionName: item.sectionName,
          name: item.name,
          eventAction: item.gaData[0].eventAction,
          totalEvents: Number(item.gaData[0].totalEvents),
        });
      } else if (numberOfgaItems > 1) {
        //handle duplication from GA e.g. /course/:id /course/:slug/:id
        item.gaData
          .reduce((acc, current) => {
            let totalEvents = 0;
            const x = acc.find(
              (baz) => baz.eventAction === current.eventAction
            );
            if (!x) {
              return acc.concat([current]);
            } else {
              if (acc[0] && acc[0].totalEvents) {
                totalEvents = Number(acc[0].totalEvents);
                totalEvents += Number(current.totalEvents);
              }
              return [
                {
                  ...acc[0],
                  totalEvents,
                  sectionName: item.sectionName,
                  name: item.name,
                },
              ];
            }
          }, [])
          .forEach((item) => flatList.push(item));
      } else {
        flatList.push({
          sectionName: item.sectionName,
          name: item.name,
          eventAction: "n/a",
          totalEvents: 0,
        });
      }
    });
    return flatList;
  };

  sortSectionAndName = (a, b) => {
    if (this.state.sortOrder) {
      if (a.section < b.section) {
        return -1;
      }
      if (a.section > b.section) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
    } else {
      if (a.section > b.sectionName) {
        return -1;
      }
      if (a.section < b.sectionName) {
        return 1;
      }
      if (a.name > b.name) {
        return -1;
      }
      if (a.name < b.name) {
        return 1;
      }
    }
  };

  sortColumn = (a, b) => {
    if (this.state.sortOrder) {
      if (a[this.state.sortBy] > b[this.state.sortBy]) {
        return -1;
      }
      if ([this.state.sortBy] < [this.state.sortBy]) {
        return 1;
      }
      return 0;
    } else {
      if (b[this.state.sortBy] < b[this.state.sortBy]) {
        return -1;
      }
      if (a[this.state.sortBy] > b[this.state.sortBy]) {
        return 1;
      }
      return 0;
    }
  };

  sortUsageData = (a, b) => {
    if (!this.state.sortBy && this.state.sortingTable === "usage") return 0;
    if (this.state.sortBy === "sectionName")
      return this.sortSectionAndName(a, b);
    return this.sortColumn(a, b);
  };

  sortInteractionData = (a, b) => {
    if (!this.state.sortBy && this.state.sortingTable === "interction")
      return 0;
    if (this.state.sortBy === "sectionName")
      return this.sortSectionAndName(a, b);
    return this.sortColumn(a, b);
  };

  sortTable = (table, column, toggle) => {
    this.setState({ sortingTable: table });
    this.setState({ sortBy: column });
    this.setState({ sortOrder: !toggle });
  };

  printInteractionType(interaction) {
    switch (interaction) {
      case "task_interaction":
        return _l`task_interaction`;
      case "video_interaction":
        return _l`video_interaction`;
      case "download_interaction":
        return _l`download_interaction`;
      case "slideshow_interaction":
        return _l`slideshow_interaction`;
      case "discussion_interaction":
        return _l`discussion_interaction`;
      case "audio_interaction":
        return _l`audio_interaction`;
      default:
        return "n/a";
    }
  }

  render() {
    const { loading, loadingDetails, courses, error, sortBy } = this.state;
    const { interactionData, data } = this.props;
    const standardActions = [
      <RaisedButton
        key="close"
        label={_l`close`}
        secondary
        onTouchTap={() => {
          this.refs.interactionDialog.dismiss();
        }}
      />,
    ];
    const menuItems = courses.map((c) => ({
      payload: c.slug,
      id: c.id,
      text: c.name,
    }));
    menuItems.unshift({ payload: "none", text: "Select course" });
    return (
      <div style={{ overflowY: "scroll", height: "calc(100vh - 200px)" }}>
        <div className={css.dropdown}>
          <SelectField
            style={{ width: "100%" }}
            onChange={this.handleChange}
            menuItems={menuItems}
          />
          {error && error}
        </div>
        {!loading && (
          <div>
            {
              <div>
                <div style={{ margin: 20, marginLeft: "34px" }}>
                  <Paper
                    style={{
                      maxWidth: 1200,
                      margin: "auto",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: 22,
                        lineHeight: "28px",
                        borderRadius: "2px",
                        padding: "20px",

                        background: "#777",
                        color: "#fff",
                      }}
                    >{_l`Interaction`}</h2>

                    <Table
                      height={"400px"}
                      style={{
                        maxWidth: 1200,
                        margin: "auto",
                      }}
                      fixedHeader={true}
                      multiSelectable={false}
                    >
                      <TableHeader
                        selectAllSelected={false}
                        adjustForCheckbox={false}
                        displaySelectAll={false}
                        enableSelectAll={false}
                      >
                        <TableRow>
                          <TableHeaderColumn
                            style={{ color: "#656565", fontSize: "13px" }}
                            tooltip={_l`page`}
                          >
                            {_l`page`}
                            <IconButton
                              onClick={(e) =>
                                this.sortTable(
                                  "usage",
                                  "sectionName",
                                  this.state.sortOrder
                                )
                              }
                            >
                              {!this.state.sortOrder && (
                                <Icons.NavigationArrowDropDown />
                              )}
                              {this.state.sortOrder && (
                                <Icons.NavigationArrowDropUp />
                              )}
                            </IconButton>
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            style={{ color: "#656565", fontSize: "13px" }}
                            tooltip={_l`sessions`}
                          >
                            {_l`sessions`}
                            <IconButton
                              onClick={(e) =>
                                this.sortTable(
                                  "usage",
                                  "sessions",
                                  this.state.sortOrder
                                )
                              }
                            >
                              {!this.state.sortOrder && (
                                <Icons.NavigationArrowDropDown />
                              )}
                              {this.state.sortOrder && (
                                <Icons.NavigationArrowDropUp />
                              )}
                            </IconButton>
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            style={{ color: "#656565", fontSize: "13px" }}
                            tooltip={_l`TimeSpent`}
                          >
                            {_l`TimeSpent`}
                            <IconButton
                              onClick={(e) =>
                                this.sortTable(
                                  "usage",
                                  "avgSessionDuration",
                                  this.state.sortOrder
                                )
                              }
                            >
                              {!this.state.sortOrder && (
                                <Icons.NavigationArrowDropDown />
                              )}
                              {this.state.sortOrder && (
                                <Icons.NavigationArrowDropUp />
                              )}
                            </IconButton>
                          </TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody displayRowCheckbox={false} stripedRows={false}>
                        {!loading &&
                          data &&
                          this.mapUsageData(data)
                            .sort(this.sortUsageData)
                            .map((page, i) => {
                              const minutes = Math.floor(
                                page.avgSessionDuration / 60
                              );
                              const seconds = Math.floor(
                                page.avgSessionDuration - minutes * 60
                              );
                              return (
                                <TableRow
                                  key={page.id}
                                  style={{ cursor: "pointer" }}
                                >
                                  <TableRowColumn style={{ fontSize: "15px" }}>
                                    <strong>{page.sectionName}</strong> -{" "}
                                    {page.name}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {page.sessions}
                                  </TableRowColumn>
                                  {(page && page.avgSessionDuration && (
                                    <TableRowColumn
                                      style={{ fontSize: "15px" }}
                                    >
                                      {minutes + ":" + seconds}
                                    </TableRowColumn>
                                  )) || (
                                    <TableRowColumn
                                      style={{ fontSize: "15px" }}
                                    >
                                      {"N/A"}
                                    </TableRowColumn>
                                  )}
                                </TableRow>
                              );
                            })}
                        )}
                      </TableBody>
                    </Table>
                  </Paper>
                </div>
                <div style={{ margin: 20, marginLeft: "34px" }}>
                  <Paper style={{ maxWidth: 1200, margin: "auto" }}>
                    <h2
                      style={{
                        fontSize: 22,
                        lineHeight: "28px",
                        borderRadius: "2px",
                        padding: "20px",

                        background: "#777",
                        color: "#fff",
                      }}
                    >{_l`Course Interactions`}</h2>
                    <Table
                      style={{
                        margin: "auto",
                      }}
                      height={"400px"}
                      fixedHeader={true}
                      multiSelectable={false}
                    >
                      <TableHeader
                        selectAllSelected={false}
                        adjustForCheckbox={false}
                        displaySelectAll={false}
                        enableSelectAll={false}
                      >
                        <TableRow>
                          <TableHeaderColumn
                            style={{ color: "#656565", fontSize: "13px" }}
                            tooltip={_l`page`}
                          >
                            {_l`page`}
                            <IconButton
                              onClick={(e) =>
                                this.sortTable(
                                  "interaction",
                                  "sectionName",
                                  this.state.sortOrder
                                )
                              }
                            >
                              {!this.state.sortOrder && (
                                <Icons.NavigationArrowDropDown />
                              )}
                              {this.state.sortOrder && (
                                <Icons.NavigationArrowDropUp />
                              )}
                            </IconButton>
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            style={{ color: "#656565" }}
                            tooltip={_l`Interaction Type`}
                          >
                            {_l`Interaction Type`}
                            <IconButton
                              onClick={(e) =>
                                this.sortTable(
                                  "interaction",
                                  "eventAction",
                                  this.state.sortOrder
                                )
                              }
                            >
                              {!this.state.sortOrder && (
                                <Icons.NavigationArrowDropDown />
                              )}
                              {this.state.sortOrder && (
                                <Icons.NavigationArrowDropUp />
                              )}
                            </IconButton>
                          </TableHeaderColumn>
                          <TableHeaderColumn
                            style={{ color: "#656565" }}
                            tooltip={_l`Amount`}
                          >
                            {_l`Amount`}
                            <IconButton
                              onClick={(e) =>
                                this.sortTable(
                                  "interaction",
                                  "totalEvents",
                                  this.state.sortOrder
                                )
                              }
                            >
                              {!this.state.sortOrder && (
                                <Icons.NavigationArrowDropDown />
                              )}
                              {this.state.sortOrder && (
                                <Icons.NavigationArrowDropUp />
                              )}
                            </IconButton>
                          </TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody displayRowCheckbox={false} stripedRows={false}>
                        {!loading &&
                          interactionData &&
                          this.mapInteractionData(interactionData)
                            .sort(this.sortInteractionData)
                            .map((page, i) => {
                              return (
                                <TableRow key={i} style={{ cursor: "pointer" }}>
                                  <TableRowColumn style={{ fontSize: "15px" }}>
                                    <strong>{page.sectionName}</strong> -{" "}
                                    {page.name}
                                  </TableRowColumn>
                                  <TableRowColumn style={{ fontSize: "15px" }}>
                                    {_l([page.eventAction])}
                                  </TableRowColumn>
                                  <TableRowColumn style={{ fontSize: "15px" }}>
                                    {page.totalEvents}
                                  </TableRowColumn>
                                </TableRow>
                              );
                            })}
                      </TableBody>
                    </Table>
                  </Paper>
                </div>
              </div>
            }
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/StatisticsContainer.js